import React from 'react';
import './SideBar.scss';
import logowhite from '../../assets/sidebar_logo.png';
import { Link } from 'react-router-dom';
import { sidebarData } from './SideBarData';
import { useHistory, useLocation } from 'react-router-dom';
import { SvgList } from '../';

const Sidebar = () => {
  const history = useHistory();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem('authData');

    history.push('/');
  };

  return (
    location.pathname !== '/' && (
      <div className="sidebar">
        <img className="logo" src={logowhite} />
        <div className="sidebar_scroll">
          {sidebarData.manuList.map((item, i) => {
            return (
              <div key={i} className="wrap_column">
                <h5 className="heading">{item.manuName}</h5>
                <ul className="nav_list">
                  {item.subMenu.map((subMenuItem) => {
                    return (
                      <li
                        className={
                          subMenuItem.allPaths.includes(location.pathname) || location.pathname.includes(subMenuItem.route) ? 'active' : ''
                        }
                        key={subMenuItem.name}
                      >
                        <Link to={subMenuItem.route} className="link-style">
                          <SvgList name={subMenuItem.iconName} />
                          {subMenuItem.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
          <ul className="nav_list">
            <li>
              <Link to={''} className="link-style" onClick={handleLogout}>
                <SvgList name={'logout'} />
                {'Logout'}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    )
  );
};

export default Sidebar;

